import _ from 'lodash';
import { useEffect } from 'react';
import { useExtractVideoFromId, VideoSourceEnum } from 'api';
import { CreativeVideo } from '../../../../../types';
import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useAsyncExtractVideo = () => {
  const store = useCreativeTemplatesBuilderStore();

  const [extractVideo, { data }] = useExtractVideoFromId();

  const { id } = _.find(store.videos, 'loading') || {};

  useEffect(() => {
    if (!id) return;
    extractVideo({ variables: { videoId: id } });
  }, [id]);

  useEffect(() => {
    if (!data) return;

    if (data.extractVideoFromId.video?.source) {
      store.setVideos(
        _.map(store.videos, (video) =>
          video.id === id ? { ...data.extractVideoFromId.video, videoSource: VideoSourceEnum.ACCOUNT } : video
        ) as CreativeVideo[]
      );

      return;
    }

    setTimeout(() => extractVideo({ variables: { videoId: id } }), 1000);
  }, [data]);

  return {};
};
